module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.7b929e8928670d642627.js");
};